import { render, staticRenderFns } from "./EditBestellingdag.vue?vue&type=template&id=5a0f65e0&scoped=true&"
import script from "./EditBestellingdag.vue?vue&type=script&lang=js&"
export * from "./EditBestellingdag.vue?vue&type=script&lang=js&"
import style0 from "./EditBestellingdag.vue?vue&type=style&index=0&id=5a0f65e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0f65e0",
  null
  
)

export default component.exports